import React, { useState, useEffect } from 'react';
import logo from '../../assets/Logo.png'
import { motion } from "framer-motion";
import { Link } from 'react-router-dom';
import { FaLinkedin, FaEnvelope, FaArrowUp} from 'react-icons/fa';
import header from '../../assets/header.png'

const CookiesPolicy = () => {
   const [showScrollButton, setShowScrollButton] = useState(false);
  
    useEffect(() => {
      const handleScroll = () => {
        if (window.pageYOffset > 300) {
          setShowScrollButton(true);
        } else {
          setShowScrollButton(false);
        }
      };
  
      window.addEventListener('scroll', handleScroll);
      return () => window.removeEventListener('scroll', handleScroll);
    }, []);
  
    const scrollToTop = () => {
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    };
  

  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-50 to-gray-100 py-12 px-4 sm:px-6 lg:px-8">
       {/* Scroll to top button */}
            {showScrollButton && (
              <motion.button
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                exit={{ opacity: 0 }}
                onClick={scrollToTop}
                className="fixed bottom-8 right-8 z-50 p-3 bg-blue-600 rounded-full shadow-lg hover:bg-blue-700 transition-colors duration-200 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-opacity-50"
                aria-label="Scroll to top"
              >
                <FaArrowUp className="text-white text-xl" />
              </motion.button>
            )}
      
      <div className="max-w-5xl mx-auto">
        {/* Header */}
        <div className="flex justify-between items-center mb-4">
          <div className="w-auto flex-shrink-0">
            <Link to="/">
              <img
                src={header}
                alt="Vorstel logo"
                width="140"
                height="35"
                className="w-[140px] h-auto object-contain cursor-pointer hover:opacity-80 transition-opacity"
              />
            </Link>
          </div>
          <div className={`flex items-center space-x-4`}>
            <a href="mailto:sales@vorstel.com" className="p-1" aria-label="Email Vorstel sales team">
              <FaEnvelope className="text-lg sm:text-xl text-gray-700 hover:text-blue-500" aria-hidden="true" />
            </a>
            <a href="https://www.linkedin.com/company/vorstel-gmbh/about/" target="_blank" rel="noopener noreferrer" className="p-1" aria-label="Vorstel on LinkedIn (opens in a new tab)">
              <FaLinkedin className="text-lg sm:text-xl text-gray-700 hover:text-blue-500" aria-hidden="true" />
            </a>
          </div>
        </div>

        {/* Main content card */}
        <div className="bg-white shadow-xl rounded-lg overflow-hidden">
          {/* Hero section */}
          <div className="bg-gradient-to-r from-blue-600 to-blue-800 py-12 px-8 text-center">
            <h1 className="text-4xl font-bold text-white mb-3">Cookies Policy</h1>
            <p className="text-blue-100 max-w-2xl mx-auto">
              Last updated: {new Date().toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' })}
            </p>
          </div>

          {/* Content with sticky sidebar */}
          <div className="flex flex-col lg:flex-row">
            {/* Sticky sidebar navigation */}
            <div className="lg:w-1/4 p-6 bg-gray-50 border-r border-gray-200 lg:sticky lg:top-0 lg:h-screen lg:overflow-y-auto">
              <h3 className="font-semibold text-gray-700 mb-4">Quick Navigation</h3>
              <ul className="space-y-3">
                {[
                  'What Are Cookies',
                  'Cookie types',
                  'Cookie usage',
                  'Managing cookies',
                  'Cookie consent',
                ].map((item) => (
                  <li key={item}>
                    <a
                      href={`#${item.toLowerCase().replace(' ', '-')}`}
                      className="text-blue-600 hover:text-blue-800 hover:underline text-sm"
                    >
                      {item}
                    </a>
                  </li>
                ))}
              </ul>
              <div className="mt-8">
                {/* <button className="w-full px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 transition-colors">
                  Cookie Settings
                </button> */}
              </div>
            </div>

            {/* Main content */}
            <div className="lg:w-3/4 p-8">
              <div className="prose prose-blue max-w-none">
                {/* What Are Cookies? */}
                <section id="what-are-cookies" className="mb-12 scroll-mt-20">
                  <h2 className="text-2xl font-semibold text-gray-800 mb-4 flex items-center">
                    <span className="mr-2">1.</span> What Are Cookies?
                  </h2>
                  <div className="space-y-6 text-gray-600">
                    <p>
                      Cookies are small text files placed on your device (computer, phone, or tablet) when you visit our website. They serve as digital "memory tags" that help our Site function properly and improve your experience.
                    </p>

                    {/* Cookie Functions */}
                    <div className="bg-blue-50 p-4 rounded-lg">
                      <h3 className="text-lg font-semibold text-blue-800 mb-3">Primary Cookie Functions:</h3>
                      <ul className="space-y-3">
                        <li className="flex items-start">
                          <span className="text-blue-600 mr-2 text-xl">📝</span>
                          <div>
                            <span className="font-medium">Preference Memory:</span> Remember your settings (language selection, login sessions, display preferences)
                          </div>
                        </li>
                        <li className="flex items-start">
                          <span className="text-blue-600 mr-2 text-xl">📊</span>
                          <div>
                            <span className="font-medium">Interaction Tracking:</span> Record pages visited, buttons clicked, and time spent on our Site
                          </div>
                        </li>
                        <li className="flex items-start">
                          <span className="text-blue-600 mr-2 text-xl">🎯</span>
                          <div>
                            <span className="font-medium">Personalization:</span> Tailor content and recommendations based on your behavior
                          </div>
                        </li>
                      </ul>
                    </div>

                    {/* Beyond Cookies */}
                    <div className="bg-purple-50 p-4 rounded-lg border-l-4 border-purple-400">
                      <h3 className="text-lg font-semibold text-purple-800 mb-2">Beyond Cookies:</h3>
                      <p className="mb-3">We may also use similar tracking technologies including:</p>
                      <ul className="list-disc pl-5 space-y-2">
                        <li>
                          <span className="font-medium">Web beacons/pixels:</span> Invisible images in emails that track opens and clicks
                        </li>
                        <li>
                          <span className="font-medium">Local storage:</span> Browser-based data caching for faster loading
                        </li>
                        <li>
                          <span className="font-medium">Session identifiers:</span> Temporary server tokens that maintain your login state
                        </li>
                        <li>
                          <span className="font-medium">Device fingerprinting:</span> Technical characteristics used for fraud prevention
                        </li>
                      </ul>
                    </div>

                    {/* Technical Note */}
                    <div className="bg-gray-50 p-4 rounded-lg text-sm">
                      <p>
                        <span className="font-medium">Technical Note:</span> Cookies are generally categorized as "first-party" (set by us) or "third-party" (set by services we use), and may have expiration durations ranging from session-length to several years.
                      </p>
                    </div>
                  </div>
                </section>
                {/* Types of Cookies We Use */}
                <section id="cookie-types" className="mb-12 scroll-mt-20">
                  <h2 className="text-2xl font-semibold text-gray-800 mb-4 flex items-center">
                    <span className="mr-2">2.</span> Types of Cookies We Use
                  </h2>
                  <div className="space-y-6 text-gray-600">
                    <p>
                      We use different categories of cookies and tracking technologies, each serving specific purposes:
                    </p>

                    {/* Cookie Table - Desktop */}
                    <div className="hidden md:block overflow-x-auto">
                      <table className="w-full border-collapse">
                        <thead>
                          <tr className="bg-gray-100">
                            <th className="p-3 text-left border-b border-gray-300">Category</th>
                            <th className="p-3 text-left border-b border-gray-300">Purpose & Examples</th>
                            <th className="p-3 text-left border-b border-gray-300">Consent Required</th>
                            <th className="p-3 text-left border-b border-gray-300">Retention</th>
                          </tr>
                        </thead>
                        <tbody>
                          {/* Essential */}
                          <tr className="border-b border-gray-200 hover:bg-gray-50">
                            <td className="p-3 font-medium">Essential</td>
                            <td className="p-3">
                              <p>Enable core site functions:</p>
                              <ul className="list-disc pl-5 mt-1 space-y-1">
                                <li>Security features (e.g., CSRF tokens)</li>
                                <li>Session maintenance (login/user preferences)</li>
                                <li>Load balancing</li>
                              </ul>
                            </td>
                            <td className="p-3 text-center">
                              <span className="inline-block px-2 py-1 bg-red-100 text-red-800 rounded-full text-sm">Never ❌</span>
                            </td>
                            <td className="p-3">Session / 24h</td>
                          </tr>

                          {/* Functional */}
                          <tr className="border-b border-gray-200 hover:bg-gray-50">
                            <td className="p-3 font-medium">Functional</td>
                            <td className="p-3">
                              <p>Enhance user experience:</p>
                              <ul className="list-disc pl-5 mt-1 space-y-1">
                                <li>Remember language/region</li>
                                <li>Save accessibility settings (e.g., text size)</li>
                                <li>Chatbot session continuity</li>
                              </ul>
                            </td>
                            <td className="p-3 text-center">
                              <span className="inline-block px-2 py-1 bg-orange-100 text-orange-800 rounded-full text-sm">Opt-Out 🔶</span>
                            </td>
                            <td className="p-3">30-90 days</td>
                          </tr>

                          {/* Analytical */}
                          <tr className="border-b border-gray-200 hover:bg-gray-50">
                            <td className="p-3 font-medium">Analytical</td>
                            <td className="p-3">
                              <p>Analyze traffic patterns:</p>
                              <ul className="list-disc pl-5 mt-1 space-y-1">
                                <li>Google Analytics (_ga)</li>
                                <li>Heatmaps (e.g., Hotjar)</li>
                                <li>Error rate monitoring</li>
                              </ul>
                            </td>
                            <td className="p-3 text-center">
                              <span className="inline-block px-2 py-1 bg-green-100 text-green-800 rounded-full text-sm">Opt-In ✅</span>
                            </td>
                            <td className="p-3">2-24 months</td>
                          </tr>

                          {/* Marketing */}
                          <tr className="border-b border-gray-200 hover:bg-gray-50">
                            <td className="p-3 font-medium">Marketing</td>
                            <td className="p-3">
                              <p>Deliver targeted ads:</p>
                              <ul className="list-disc pl-5 mt-1 space-y-1">
                                <li>Meta Pixel (retargeting)</li>
                                <li>LinkedIn Insights Tag</li>
                                <li>Ad performance tracking</li>
                              </ul>
                            </td>
                            <td className="p-3 text-center">
                              <span className="inline-block px-2 py-1 bg-green-100 text-green-800 rounded-full text-sm">Opt-In ✅</span>
                            </td>
                            <td className="p-3">30-180 days</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>

                    {/* Cookie Cards - Mobile */}
                    <div className="md:hidden space-y-4">
                      {/* Essential */}
                      <div className="border border-gray-200 rounded-lg p-4">
                        <div className="flex justify-between items-start">
                          <h3 className="font-medium">Essential</h3>
                          <span className="px-2 py-1 bg-red-100 text-red-800 rounded-full text-xs">Never ❌</span>
                        </div>
                        <div className="mt-2">
                          <p className="text-sm font-medium">Purpose & Examples:</p>
                          <ul className="list-disc pl-5 mt-1 space-y-1 text-sm">
                            <li>Security features (CSRF tokens)</li>
                            <li>Session maintenance</li>
                            <li>Load balancing</li>
                          </ul>
                        </div>
                        <p className="mt-2 text-sm"><span className="font-medium">Retention:</span> Session / 24h</p>
                      </div>

                      {/* Functional */}
                      <div className="border border-gray-200 rounded-lg p-4">
                        <div className="flex justify-between items-start">
                          <h3 className="font-medium">Functional</h3>
                          <span className="px-2 py-1 bg-orange-100 text-orange-800 rounded-full text-xs">Opt-Out 🔶</span>
                        </div>
                        <div className="mt-2">
                          <p className="text-sm font-medium">Purpose & Examples:</p>
                          <ul className="list-disc pl-5 mt-1 space-y-1 text-sm">
                            <li>Remember language/region</li>
                            <li>Accessibility settings</li>
                            <li>Chatbot session continuity</li>
                          </ul>
                        </div>
                        <p className="mt-2 text-sm"><span className="font-medium">Retention:</span> 30-90 days</p>
                      </div>

                      {/* Analytical */}
                      <div className="border border-gray-200 rounded-lg p-4">
                        <div className="flex justify-between items-start">
                          <h3 className="font-medium">Analytical</h3>
                          <span className="px-2 py-1 bg-green-100 text-green-800 rounded-full text-xs">Opt-In ✅</span>
                        </div>
                        <div className="mt-2">
                          <p className="text-sm font-medium">Purpose & Examples:</p>
                          <ul className="list-disc pl-5 mt-1 space-y-1 text-sm">
                            <li>Google Analytics (_ga)</li>
                            <li>Heatmaps (Hotjar)</li>
                            <li>Error rate monitoring</li>
                          </ul>
                        </div>
                        <p className="mt-2 text-sm"><span className="font-medium">Retention:</span> 2-24 months</p>
                      </div>

                      {/* Marketing */}
                      <div className="border border-gray-200 rounded-lg p-4">
                        <div className="flex justify-between items-start">
                          <h3 className="font-medium">Marketing</h3>
                          <span className="px-2 py-1 bg-green-100 text-green-800 rounded-full text-xs">Opt-In ✅</span>
                        </div>
                        <div className="mt-2">
                          <p className="text-sm font-medium">Purpose & Examples:</p>
                          <ul className="list-disc pl-5 mt-1 space-y-1 text-sm">
                            <li>Meta Pixel (retargeting)</li>
                            <li>LinkedIn Insights Tag</li>
                            <li>Ad performance tracking</li>
                          </ul>
                        </div>
                        <p className="mt-2 text-sm"><span className="font-medium">Retention:</span> 30-180 days</p>
                      </div>
                    </div>

                    {/* Additional Note */}
                    <div className="bg-gray-50 p-4 rounded-lg text-sm">
                      <p>
                        <span className="font-medium">Note:</span> Retention periods may vary slightly based on specific cookie implementations and legal requirements.
                      </p>
                    </div>
                  </div>
                </section>

                {/* How We Use Cookies */}
                <section id="cookie-usage" className="mb-12 scroll-mt-20">
                  <h2 className="text-2xl font-semibold text-gray-800 mb-6 flex items-center">
                    <span className="mr-2">3.</span> How We Use Cookies
                  </h2>
                  <div className="space-y-8 text-gray-600">
                    <p>
                      We use cookies and similar technologies for the following purposes:
                    </p>

                    {/* Core Functionality */}
                    <div className="border border-blue-100 rounded-lg overflow-hidden">
                      <div className="bg-blue-50 p-4 border-b border-blue-100">
                        <h3 className="text-lg font-semibold text-blue-800 flex items-center">
                          <span className="w-6 h-6 bg-blue-100 text-blue-800 rounded-full flex items-center justify-center mr-3">1</span>
                          Ensure Core Functionality
                        </h3>
                      </div>
                      <div className="p-4">
                        <ul className="list-disc pl-5 space-y-3">
                          <li>Maintain secure user sessions (e.g., keep you logged in during navigation)</li>
                          <li>Prevent fraudulent activity and cyber attacks (CSRF protection)</li>
                          <li>Balance website traffic across servers for optimal performance</li>
                          <li>Enable shopping cart functionality for e-commerce features</li>
                        </ul>
                      </div>
                    </div>

                    {/* Personalize Experience */}
                    <div className="border border-purple-100 rounded-lg overflow-hidden">
                      <div className="bg-purple-50 p-4 border-b border-purple-100">
                        <h3 className="text-lg font-semibold text-purple-800 flex items-center">
                          <span className="w-6 h-6 bg-purple-100 text-purple-800 rounded-full flex items-center justify-center mr-3">2</span>
                          Personalize Experience
                        </h3>
                      </div>
                      <div className="p-4">
                        <ul className="list-disc pl-5 space-y-3">
                          <li>Remember language/region preferences across visits</li>
                          <li>Save accessibility settings (e.g., text size, color contrast)</li>
                          <li>Retain form progress/data during multi-page processes</li>
                          <li>Maintain chatbot conversation history during sessions</li>
                        </ul>
                      </div>
                    </div>

                    {/* Analyze & Improve */}
                    <div className="border border-green-100 rounded-lg overflow-hidden">
                      <div className="bg-green-50 p-4 border-b border-green-100">
                        <h3 className="text-lg font-semibold text-green-800 flex items-center">
                          <span className="w-6 h-6 bg-green-100 text-green-800 rounded-full flex items-center justify-center mr-3">3</span>
                          Analyze & Improve Performance
                        </h3>
                      </div>
                      <div className="p-4">
                        <ul className="list-disc pl-5 space-y-3">
                          <li>Track traffic sources and campaign effectiveness (e.g., Google Analytics)</li>
                          <li>Identify popular content and feature usage patterns</li>
                          <li>Measure page load speeds and technical errors</li>
                          <li>Test design changes via A/B testing frameworks</li>
                          <li>Understand user navigation paths through heatmaps</li>
                        </ul>
                      </div>
                    </div>

                    {/* Targeted Advertising */}
                    <div className="border border-orange-100 rounded-lg overflow-hidden">
                      <div className="bg-orange-50 p-4 border-b border-orange-100">
                        <h3 className="text-lg font-semibold text-orange-800 flex items-center">
                          <span className="w-6 h-6 bg-orange-100 text-orange-800 rounded-full flex items-center justify-center mr-3">4</span>
                          Deliver Targeted Advertising <span className="ml-2 text-sm font-normal">(Only with your explicit consent)</span>
                        </h3>
                      </div>
                      <div className="p-4">
                        <ul className="list-disc pl-5 space-y-3">
                          <li>Retarget users across platforms (e.g., Meta, LinkedIn, Google ads)</li>
                          <li>Limit ad repetition frequency to improve experience</li>
                          <li>Measure campaign ROI and conversion tracking</li>
                          <li>Build audience segments based on content engagement</li>
                          <li>Serve location-relevant promotions when applicable</li>
                        </ul>
                      </div>
                    </div>

                    {/* Third-Party Integrations */}
                    <div className="border border-indigo-100 rounded-lg overflow-hidden">
                      <div className="bg-indigo-50 p-4 border-b border-indigo-100">
                        <h3 className="text-lg font-semibold text-indigo-800 flex items-center">
                          <span className="w-6 h-6 bg-indigo-100 text-indigo-800 rounded-full flex items-center justify-center mr-3">5</span>
                          Enable Third-Party Integrations
                        </h3>
                      </div>
                      <div className="p-4">
                        <ul className="list-disc pl-5 space-y-3">
                          <li>Social media sharing buttons (e.g., Twitter, LinkedIn, Facebook)</li>
                          <li>Embedded content players (e.g., YouTube videos, Spotify widgets)</li>
                          <li>Chat support widgets (e.g., Intercom, Drift)</li>
                          <li>Payment processors (e.g., Stripe, PayPal checkout)</li>
                          <li>Map integrations (e.g., Google Maps location finders)</li>
                        </ul>
                      </div>
                    </div>

                    {/* Consent Note */}
                    <div className="bg-gray-50 p-4 rounded-lg border-l-4 border-gray-400">
                      <p className="font-medium">About Consent:</p>
                      <p>Non-essential cookies (categories 3-5) are only placed after obtaining your explicit consent via our cookie banner. You can modify your preferences at any time through our Cookie Settings page.</p>
                    </div>
                  </div>
                </section>

                {/* Managing Cookies */}
                <section id="managing-cookies" className="mb-12 scroll-mt-20">
                  <h2 className="text-2xl font-semibold text-gray-800 mb-6 flex items-center">
                    <span className="mr-2">4.</span> Managing Cookies
                  </h2>
                  <div className="space-y-8 text-gray-600">
                    <p>
                      You have full control over cookie usage through these methods:
                    </p>

                    {/* Browser Settings */}
                    <div className="border border-blue-100 rounded-lg overflow-hidden">
                      <div className="bg-blue-50 p-4 border-b border-blue-100">
                        <h3 className="text-lg font-semibold text-blue-800 flex items-center">
                          <span className="w-6 h-6 bg-blue-100 text-blue-800 rounded-full flex items-center justify-center mr-3">1</span>
                          Browser Settings
                        </h3>
                      </div>
                      <div className="p-4">
                        <p className="mb-3">Control cookies globally via:</p>
                        <ul className="list-disc pl-5 space-y-2">
                          <li>
                            <span className="font-medium">Chrome:</span> Settings → Privacy → Clear browsing data
                          </li>
                          <li>
                            <span className="font-medium">Safari:</span> Preferences → Privacy → Manage Website Data
                          </li>
                          <li>
                            <span className="font-medium">Firefox:</span> Options → Privacy & Security → Cookies
                          </li>
                          <li>
                            <span className="font-medium">Edge:</span> Settings → Privacy, search, and services → Clear browsing data
                          </li>
                        </ul>
                        <div className="mt-4 bg-yellow-50 p-3 rounded text-sm">
                          <span className="font-medium">Note:</span> Blocking all cookies may break essential site functionality.
                        </div>
                      </div>
                    </div>

                    {/* Consent Banner */}
                    <div className="border border-purple-100 rounded-lg overflow-hidden">
                      <div className="bg-purple-50 p-4 border-b border-purple-100">
                        <h3 className="text-lg font-semibold text-purple-800 flex items-center">
                          <span className="w-6 h-6 bg-purple-100 text-purple-800 rounded-full flex items-center justify-center mr-3">2</span>
                          Our Consent Banner
                        </h3>
                      </div>
                      <div className="p-4">
                        <p className="mb-3">Customize preferences in real-time:</p>
                        <ul className="space-y-3">
                          <li className="flex items-start">
                            <span className="text-purple-600 mr-2 text-xl">⚙️</span>
                            <span><span className="font-medium">Adjust categories:</span> Toggle analytics/marketing cookies on/off</span>
                          </li>
                          <li className="flex items-start">
                            <span className="text-purple-600 mr-2 text-xl">🔄</span>
                            <span><span className="font-medium">Withdraw consent:</span> Revoke permissions anytime</span>
                          </li>
                          <li className="flex items-start">
                            <span className="text-purple-600 mr-2 text-xl">🗑️</span>
                            <span><span className="font-medium">Delete cookies:</span> One-click removal of non-essentials</span>
                          </li>
                        </ul>
                        <p className="mt-4">
                          <span className="font-medium">Access via:</span> Cookie icon (<span className="inline-block w-4 h-4 bg-gray-300 rounded-sm"></span>) in bottom corner of any page
                        </p>
                      </div>
                    </div>

                    {/* Industry Opt-Out Tools */}
                    <div className="border border-green-100 rounded-lg overflow-hidden">
                      <div className="bg-green-50 p-4 border-b border-green-100">
                        <h3 className="text-lg font-semibold text-green-800 flex items-center">
                          <span className="w-6 h-6 bg-green-100 text-green-800 rounded-full flex items-center justify-center mr-3">3</span>
                          Industry Opt-Out Tools
                        </h3>
                      </div>
                      <div className="p-4">
                        <p className="mb-3">Opt out of third-party tracking:</p>
                        <ul className="list-disc pl-5 space-y-2">
                          <li>
                            <a href="https://optout.aboutads.info/" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:underline">YourAdChoices</a> (US)
                          </li>
                          <li>
                            <a href="https://www.youronlinechoices.com/" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:underline">EDAA</a> (EU)
                          </li>
                          <li>
                            <a href="https://optout.networkadvertising.org/" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:underline">NAI</a> (Global)
                          </li>
                        </ul>
                      </div>
                    </div>

                    {/* Platform-Specific Controls */}
                    <div className="border border-orange-100 rounded-lg overflow-hidden">
                      <div className="bg-orange-50 p-4 border-b border-orange-100">
                        <h3 className="text-lg font-semibold text-orange-800 flex items-center">
                          <span className="w-6 h-6 bg-orange-100 text-orange-800 rounded-full flex items-center justify-center mr-3">4</span>
                          Platform-Specific Controls
                        </h3>
                      </div>
                      <div className="p-4">
                        <ul className="list-disc pl-5 space-y-2">
                          <li>
                            <a href="https://adssettings.google.com" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:underline">Google Ads Settings</a>
                          </li>
                          <li>
                            <a href="https://www.facebook.com/adpreferences" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:underline">Meta Ad Preferences</a>
                          </li>
                          <li>
                            <a href="https://www.linkedin.com/psettings/advertising" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:underline">LinkedIn Cookie Table</a>
                          </li>
                        </ul>
                      </div>
                    </div>

                    {/* Important Notice */}
                    <div className="bg-red-50 p-4 rounded-lg border-l-4 border-red-400">
                      <h3 className="text-lg font-semibold text-red-800 mb-2 flex items-center">
                        <span className="mr-2">⚠️</span> Important Notes
                      </h3>
                      <ul className="list-disc pl-5 space-y-2">
                        <li>Essential cookies cannot be disabled (site won't function properly without them)</li>
                        <li>Opt-outs are device/browser-specific (must repeat on each device)</li>
                        <li>Clearing browser cache will delete your cookie preferences</li>
                        <li>Some features may be limited if you reject certain cookies</li>
                      </ul>
                    </div>
                  </div>
                </section>

                {/* Consent */}
                <section id="cookie-consent" className="mb-12 scroll-mt-20">
                  <h2 className="text-2xl font-semibold text-gray-800 mb-6 flex items-center">
                    <span className="mr-2">5.</span> Consent
                  </h2>
                  <div className="space-y-8 text-gray-600">
                    <p>
                      Your cookie preferences are managed through the following consent framework:
                    </p>

                    {/* Explicit Opt-In */}
                    <div className="border border-green-100 rounded-lg overflow-hidden">
                      <div className="bg-green-50 p-4 border-b border-green-100">
                        <h3 className="text-lg font-semibold text-green-800 flex items-center">
                          <span className="w-6 h-6 bg-green-100 text-green-800 rounded-full flex items-center justify-center mr-3">1</span>
                          Explicit Opt-In Required
                        </h3>
                      </div>
                      <div className="p-4">
                        <ul className="list-disc pl-5 space-y-2">
                          <li>Non-essential cookies (analytics, marketing) require your active consent</li>
                          <li>First-time visitors see a clear cookie banner with accept/reject options</li>
                          <li>No pre-ticked boxes - all non-essential cookies default to "off"</li>
                        </ul>
                        <div className="mt-3 bg-white border border-green-200 p-3 rounded text-sm">
                          <span className="font-medium">Example:</span> Marketing cookies won't activate until you click "Accept" in our cookie banner.
                        </div>
                      </div>
                    </div>

                    {/* Granular Control */}
                    <div className="border border-blue-100 rounded-lg overflow-hidden">
                      <div className="bg-blue-50 p-4 border-b border-blue-100">
                        <h3 className="text-lg font-semibold text-blue-800 flex items-center">
                          <span className="w-6 h-6 bg-blue-100 text-blue-800 rounded-full flex items-center justify-center mr-3">2</span>
                          Granular Control
                        </h3>
                      </div>
                      <div className="p-4">
                        <ul className="space-y-3">
                          <li className="flex items-start">
                            <span className="text-blue-600 mr-2 text-xl">✅</span>
                            <span><span className="font-medium">Category-specific:</span> Enable/disable analytics separately from advertising cookies</span>
                          </li>
                          <li className="flex items-start">
                            <span className="text-blue-600 mr-2 text-xl">⚙️</span>
                            <span><span className="font-medium">Custom settings:</span> Fine-tune preferences via our Cookie Settings panel</span>
                          </li>
                          <li className="flex items-start">
                            <span className="text-blue-600 mr-2 text-xl">🔍</span>
                            <span><span className="font-medium">Transparency:</span> See exact cookie names and purposes before consenting</span>
                          </li>
                        </ul>
                      </div>
                    </div>

                    {/* Withdrawal */}
                    <div className="border border-purple-100 rounded-lg overflow-hidden">
                      <div className="bg-purple-50 p-4 border-b border-purple-100">
                        <h3 className="text-lg font-semibold text-purple-800 flex items-center">
                          <span className="w-6 h-6 bg-purple-100 text-purple-800 rounded-full flex items-center justify-center mr-3">3</span>
                          Withdrawal of Consent
                        </h3>
                      </div>
                      <div className="p-4">
                        <p className="mb-3">Revoke consent at any time by:</p>
                        <ul className="list-disc pl-5 space-y-2">
                          <li>Clicking "Cookie Settings" in our website footer</li>
                          <li>Clearing cookies through your browser settings</li>
                          <li>Using the "Withdraw Consent" button in your account settings (if logged in)</li>
                        </ul>
                        <div className="mt-3 bg-purple-50 p-3 rounded text-sm">
                          <span className="font-medium">Note:</span> Changes apply to future browsing sessions only and won't affect already collected data.
                        </div>
                      </div>
                    </div>

                    {/* Renewal & Exceptions */}
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                      {/* Renewal */}
                      <div className="border border-yellow-100 rounded-lg overflow-hidden">
                        <div className="bg-yellow-50 p-4 border-b border-yellow-100">
                          <h3 className="text-lg font-semibold text-yellow-800">Automatic Renewal</h3>
                        </div>
                        <div className="p-4">
                          <ul className="list-disc pl-5 space-y-2">
                            <li>Consent expires after 13 months of inactivity</li>
                            <li>You'll be re-prompted to renew preferences</li>
                            <li>Previous choices are remembered but require reconfirmation</li>
                          </ul>
                        </div>
                      </div>

                      {/* Essential Exception */}
                      <div className="border border-red-100 rounded-lg overflow-hidden">
                        <div className="bg-red-50 p-4 border-b border-red-100">
                          <h3 className="text-lg font-semibold text-red-800">Essential Cookies Exception</h3>
                        </div>
                        <div className="p-4">
                          <ul className="list-disc pl-5 space-y-2">
                            <li>Core functionality cookies deploy automatically</li>
                            <li>Enabled under "legitimate interest" (GDPR Article 6(1)(f))</li>
                            <li>Required for basic website operation</li>
                          </ul>
                        </div>
                      </div>
                    </div>

                    {/* Legal Basis */}
                    <div className="bg-gray-50 p-4 rounded-lg">
                      <h3 className="font-medium text-gray-800 mb-2">Legal Basis Summary:</h3>
                      <table className="w-full text-sm">
                        <thead>
                          <tr className="border-b border-gray-200">
                            <th className="pb-2 text-left">Cookie Type</th>
                            <th className="pb-2 text-left">Legal Basis</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr className="border-b border-gray-200">
                            <td className="py-2">Essential</td>
                            <td className="py-2">Legitimate Interest</td>
                          </tr>
                          <tr className="border-b border-gray-200">
                            <td className="py-2">Functional</td>
                            <td className="py-2">Consent (Opt-Out)</td>
                          </tr>
                          <tr>
                            <td className="py-2">Analytics/Marketing</td>
                            <td className="py-2">Explicit Consent (Opt-In)</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </section>

              </div>
            </div>
          </div>
        </div>

        {/* Footer */}
        <div className="mt-12 text-center text-gray-500 text-sm">
          <p>&copy; {new Date().getFullYear()} Vorstel. All rights reserved.</p>
          {/* <div className="mt-2 flex justify-center space-x-6">
            <a href="#" className="text-gray-500 hover:text-gray-700">Privacy Policy</a>
            <a href="#" className="text-gray-500 hover:text-gray-700">Terms of Service</a>
            <a href="#" className="text-gray-500 hover:text-gray-700">Cookies Policy</a>
          </div> */}
        </div>
      </div>
    </div>
  );
};

export default CookiesPolicy;